/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateOrganizationResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateOrganizationRequest, serializeCreateOrganizationResponse, type CreateOrganizationRequest, type CreateOrganizationResponse, type ErrorResponse, type InternalErrorResponse } from '../../models/index.js';
// @ts-ignore
import { AccessRequestNotificationSettingsRequestBuilderRequestsMetadata, type AccessRequestNotificationSettingsRequestBuilder } from './accessRequestNotificationSettings/index.js';
// @ts-ignore
import { AccessRequestsRequestBuilderNavigationMetadata, AccessRequestsRequestBuilderRequestsMetadata, type AccessRequestsRequestBuilder } from './accessRequests/index.js';
// @ts-ignore
import { AiUsageRequestBuilderRequestsMetadata, type AiUsageRequestBuilder } from './aiUsage/index.js';
// @ts-ignore
import { ApiKeysRequestBuilderNavigationMetadata, ApiKeysRequestBuilderRequestsMetadata, type ApiKeysRequestBuilder } from './apiKeys/index.js';
// @ts-ignore
import { BulkWritesRequestBuilderRequestsMetadata, type BulkWritesRequestBuilder } from './bulkWrites/index.js';
// @ts-ignore
import { CartPricingSettingsRequestBuilderRequestsMetadata, type CartPricingSettingsRequestBuilder } from './cartPricingSettings/index.js';
// @ts-ignore
import { CustomerAttributesRequestBuilderNavigationMetadata, CustomerAttributesRequestBuilderRequestsMetadata, type CustomerAttributesRequestBuilder } from './customerAttributes/index.js';
// @ts-ignore
import { FeaturesRequestBuilderRequestsMetadata, type FeaturesRequestBuilder } from './features/index.js';
// @ts-ignore
import { FulfillmentMethodsRequestBuilderNavigationMetadata, FulfillmentMethodsRequestBuilderRequestsMetadata, type FulfillmentMethodsRequestBuilder } from './fulfillmentMethods/index.js';
// @ts-ignore
import { type WithOrganizationItemRequestBuilder, WithOrganizationItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { MarketCodesRequestBuilderRequestsMetadata, type MarketCodesRequestBuilder } from './marketCodes/index.js';
// @ts-ignore
import { OrderExportSettingsRequestBuilderRequestsMetadata, type OrderExportSettingsRequestBuilder } from './orderExportSettings/index.js';
// @ts-ignore
import { OrderKindsRequestBuilderRequestsMetadata, type OrderKindsRequestBuilder } from './orderKinds/index.js';
// @ts-ignore
import { OrderReceiptSettingsRequestBuilderRequestsMetadata, type OrderReceiptSettingsRequestBuilder } from './orderReceiptSettings/index.js';
// @ts-ignore
import { OrderStatusesRequestBuilderNavigationMetadata, OrderStatusesRequestBuilderRequestsMetadata, type OrderStatusesRequestBuilder } from './orderStatuses/index.js';
// @ts-ignore
import { OrderTypesRequestBuilderNavigationMetadata, OrderTypesRequestBuilderRequestsMetadata, type OrderTypesRequestBuilder } from './orderTypes/index.js';
// @ts-ignore
import { PriceTiersRequestBuilderRequestsMetadata, type PriceTiersRequestBuilder } from './priceTiers/index.js';
// @ts-ignore
import { ProductAttributesRequestBuilderNavigationMetadata, ProductAttributesRequestBuilderRequestsMetadata, type ProductAttributesRequestBuilder } from './productAttributes/index.js';
// @ts-ignore
import { ProductOptionsRequestBuilderRequestsMetadata, type ProductOptionsRequestBuilder } from './productOptions/index.js';
// @ts-ignore
import { ResearchSettingsRequestBuilderNavigationMetadata, ResearchSettingsRequestBuilderRequestsMetadata, type ResearchSettingsRequestBuilder } from './researchSettings/index.js';
// @ts-ignore
import { SalesrepsRequestBuilderNavigationMetadata, SalesrepsRequestBuilderRequestsMetadata, type SalesrepsRequestBuilder } from './salesreps/index.js';
// @ts-ignore
import { StorefrontUsersRequestBuilderRequestsMetadata, type StorefrontUsersRequestBuilder } from './storefrontUsers/index.js';
// @ts-ignore
import { SubscriptionsRequestBuilderNavigationMetadata, type SubscriptionsRequestBuilder } from './subscriptions/index.js';
// @ts-ignore
import { TermsRequestBuilderNavigationMetadata, TermsRequestBuilderRequestsMetadata, type TermsRequestBuilder } from './terms/index.js';
// @ts-ignore
import { type UsersRequestBuilder, UsersRequestBuilderNavigationMetadata } from './users/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations
 */
export interface OrganizationsRequestBuilder extends BaseRequestBuilder<OrganizationsRequestBuilder> {
    /**
     * The accessRequestNotificationSettings property
     */
    get accessRequestNotificationSettings(): AccessRequestNotificationSettingsRequestBuilder;
    /**
     * The accessRequests property
     */
    get accessRequests(): AccessRequestsRequestBuilder;
    /**
     * The aiUsage property
     */
    get aiUsage(): AiUsageRequestBuilder;
    /**
     * The apiKeys property
     */
    get apiKeys(): ApiKeysRequestBuilder;
    /**
     * The bulkWrites property
     */
    get bulkWrites(): BulkWritesRequestBuilder;
    /**
     * The cartPricingSettings property
     */
    get cartPricingSettings(): CartPricingSettingsRequestBuilder;
    /**
     * The customerAttributes property
     */
    get customerAttributes(): CustomerAttributesRequestBuilder;
    /**
     * The features property
     */
    get features(): FeaturesRequestBuilder;
    /**
     * The fulfillmentMethods property
     */
    get fulfillmentMethods(): FulfillmentMethodsRequestBuilder;
    /**
     * The marketCodes property
     */
    get marketCodes(): MarketCodesRequestBuilder;
    /**
     * The orderExportSettings property
     */
    get orderExportSettings(): OrderExportSettingsRequestBuilder;
    /**
     * The orderKinds property
     */
    get orderKinds(): OrderKindsRequestBuilder;
    /**
     * The orderReceiptSettings property
     */
    get orderReceiptSettings(): OrderReceiptSettingsRequestBuilder;
    /**
     * The orderStatuses property
     */
    get orderStatuses(): OrderStatusesRequestBuilder;
    /**
     * The orderTypes property
     */
    get orderTypes(): OrderTypesRequestBuilder;
    /**
     * The priceTiers property
     */
    get priceTiers(): PriceTiersRequestBuilder;
    /**
     * The productAttributes property
     */
    get productAttributes(): ProductAttributesRequestBuilder;
    /**
     * The productOptions property
     */
    get productOptions(): ProductOptionsRequestBuilder;
    /**
     * The researchSettings property
     */
    get researchSettings(): ResearchSettingsRequestBuilder;
    /**
     * The salesreps property
     */
    get salesreps(): SalesrepsRequestBuilder;
    /**
     * The storefrontUsers property
     */
    get storefrontUsers(): StorefrontUsersRequestBuilder;
    /**
     * The subscriptions property
     */
    get subscriptions(): SubscriptionsRequestBuilder;
    /**
     * The terms property
     */
    get terms(): TermsRequestBuilder;
    /**
     * The users property
     */
    get users(): UsersRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.organizations.item collection
     * @param organizationId Route parameter: the organisation whose integrations to list.
     * @returns {WithOrganizationItemRequestBuilder}
     */
     byOrganizationId(organizationId: string) : WithOrganizationItemRequestBuilder;
    /**
     * Create an Organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateOrganizationResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateOrganizationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateOrganizationResponse | undefined>;
    /**
     * Create an Organization
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateOrganizationRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const OrganizationsRequestBuilderUriTemplate = "{+baseurl}/api/organizations";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrganizationsRequestBuilderNavigationMetadata: Record<Exclude<keyof OrganizationsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byOrganizationId: {
        navigationMetadata: WithOrganizationItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["organizationId"],
    },
    accessRequestNotificationSettings: {
        requestsMetadata: AccessRequestNotificationSettingsRequestBuilderRequestsMetadata,
    },
    accessRequests: {
        requestsMetadata: AccessRequestsRequestBuilderRequestsMetadata,
        navigationMetadata: AccessRequestsRequestBuilderNavigationMetadata,
    },
    aiUsage: {
        requestsMetadata: AiUsageRequestBuilderRequestsMetadata,
    },
    apiKeys: {
        requestsMetadata: ApiKeysRequestBuilderRequestsMetadata,
        navigationMetadata: ApiKeysRequestBuilderNavigationMetadata,
    },
    bulkWrites: {
        requestsMetadata: BulkWritesRequestBuilderRequestsMetadata,
    },
    cartPricingSettings: {
        requestsMetadata: CartPricingSettingsRequestBuilderRequestsMetadata,
    },
    customerAttributes: {
        requestsMetadata: CustomerAttributesRequestBuilderRequestsMetadata,
        navigationMetadata: CustomerAttributesRequestBuilderNavigationMetadata,
    },
    features: {
        requestsMetadata: FeaturesRequestBuilderRequestsMetadata,
    },
    fulfillmentMethods: {
        requestsMetadata: FulfillmentMethodsRequestBuilderRequestsMetadata,
        navigationMetadata: FulfillmentMethodsRequestBuilderNavigationMetadata,
    },
    marketCodes: {
        requestsMetadata: MarketCodesRequestBuilderRequestsMetadata,
    },
    orderExportSettings: {
        requestsMetadata: OrderExportSettingsRequestBuilderRequestsMetadata,
    },
    orderKinds: {
        requestsMetadata: OrderKindsRequestBuilderRequestsMetadata,
    },
    orderReceiptSettings: {
        requestsMetadata: OrderReceiptSettingsRequestBuilderRequestsMetadata,
    },
    orderStatuses: {
        requestsMetadata: OrderStatusesRequestBuilderRequestsMetadata,
        navigationMetadata: OrderStatusesRequestBuilderNavigationMetadata,
    },
    orderTypes: {
        requestsMetadata: OrderTypesRequestBuilderRequestsMetadata,
        navigationMetadata: OrderTypesRequestBuilderNavigationMetadata,
    },
    priceTiers: {
        requestsMetadata: PriceTiersRequestBuilderRequestsMetadata,
    },
    productAttributes: {
        requestsMetadata: ProductAttributesRequestBuilderRequestsMetadata,
        navigationMetadata: ProductAttributesRequestBuilderNavigationMetadata,
    },
    productOptions: {
        requestsMetadata: ProductOptionsRequestBuilderRequestsMetadata,
    },
    researchSettings: {
        requestsMetadata: ResearchSettingsRequestBuilderRequestsMetadata,
        navigationMetadata: ResearchSettingsRequestBuilderNavigationMetadata,
    },
    salesreps: {
        requestsMetadata: SalesrepsRequestBuilderRequestsMetadata,
        navigationMetadata: SalesrepsRequestBuilderNavigationMetadata,
    },
    storefrontUsers: {
        requestsMetadata: StorefrontUsersRequestBuilderRequestsMetadata,
    },
    subscriptions: {
        navigationMetadata: SubscriptionsRequestBuilderNavigationMetadata,
    },
    terms: {
        requestsMetadata: TermsRequestBuilderRequestsMetadata,
        navigationMetadata: TermsRequestBuilderNavigationMetadata,
    },
    users: {
        navigationMetadata: UsersRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const OrganizationsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: OrganizationsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateOrganizationResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateOrganizationRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
